var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "odilip8pwa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.100391 0 0 0 0 0.153014 0 0 0 0 0.238046 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "i9rx1d2lrb",
    d: "M8 2c2.253 0 4.226 1.088 5.903 2.877.576.615 1.077 1.271 1.5 1.928.257.397.433.71.527.897.093.188.093.408 0 .596-.094.188-.27.5-.526.897-.424.657-.925 1.313-1.501 1.928C12.226 12.912 10.253 14 8 14c-2.253 0-4.226-1.088-5.903-2.877-.576-.615-1.077-1.271-1.5-1.928-.257-.397-.433-.71-.527-.897-.093-.188-.093-.408 0-.596.094-.188.27-.5.526-.897.424-.657.925-1.313 1.501-1.928C3.774 3.088 5.747 2 8 2zm0 1.333c-1.83 0-3.483.912-4.93 2.456-.518.552-.97 1.146-1.354 1.74-.108.168-.205.326-.289.471.084.145.18.303.29.472.382.593.835 1.187 1.353 1.739 1.447 1.544 3.1 2.456 4.93 2.456 1.83 0 3.483-.912 4.93-2.456.518-.552.97-1.146 1.354-1.74.108-.168.205-.326.289-.471-.084-.145-.18-.303-.29-.472-.382-.593-.835-1.187-1.353-1.739C11.483 4.245 9.83 3.333 8 3.333zm0 2c1.473 0 2.667 1.194 2.667 2.667 0 1.473-1.194 2.667-2.667 2.667-1.473 0-2.667-1.194-2.667-2.667 0-1.473 1.194-2.667 2.667-2.667zm0 1.334c-.736 0-1.333.597-1.333 1.333S7.264 9.333 8 9.333 9.333 8.736 9.333 8 8.736 6.667 8 6.667z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#odilip8pwa)",
    transform: "translate(-1128 -371) translate(497 350) translate(631 21)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "52ysur91gc",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i9rx1d2lrb"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#i9rx1d2lrb"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    mask: "url(#52ysur91gc)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.1830adbdeda23e64f79337a57cfad658.svg";
export { ForwardRef as ReactComponent };